import jstree from 'jstree';
import $ from 'jquery';
import { isNullOrUndefined } from 'angular-ui-router';

/**
 */
exports.initializeTree = function (id, data, options, callback) {
  let treeInstance = $('#' + id).jstree({
    "core": {
      "themes": {
        "responsive": false,
        //"variant": "small",
        "icons": false
      },

      "data": data
    },
    "types": {
      "default": {
        //"icon": "fa fa-folder text-warning"
      },
      "file": {
        //"icon": "fa fa-file  text-warning"
      }
    },
    "search": {
      "case_insensitive": true,
      "show_only_matches": isNullOrUndefined(options.show_only_matches) ? false : options.show_only_matches,
      "show_only_matches_children": true,
      "search_callback": function (str, node) {
        //search for any of the words entered
        var word, words = [];
        var searchFor = str.toLowerCase().replace(/^\s+/g, '').replace(/\s+$/g, '');
        if (searchFor.indexOf(' ') >= 0) {
          words = searchFor.split(' ');
        } else {
          words = [searchFor];
        }
        for (var i = 0; i < words.length; i++) {
          word = words[i];
          let searchTerm = options.searchField == "status" ? node.original.status : node.text;
          searchTerm = isNullOrUndefined(searchTerm)? "" : searchTerm;
          if ((searchTerm || "").toLowerCase().indexOf(word) >= 0) {
            return true;
          }
        }
        return false;
      }

    },
    "checkbox": {
      "tie_selection": false
    },
    "plugins": isNullOrUndefined(options.checkbox) ? ["wholerow", "types", "search", "cookies"] : ["state", "wholerow", "types", "checkbox"]
  });

  // handle link clicks in tree nodes(support target="_blank" as well)
  let jsTreeId = "#" + id;

  //If set to open all, always open all nodes on the tree when refreshed
  if(!isNullOrUndefined(options.open_all)) {
    $(jsTreeId).bind("refresh.jstree", function (e, data)
        { $(this).jstree("open_all");})
  }

  let validNodeTypes = options.validNodeTypes;
  $(jsTreeId).on('select_node.jstree', function (e, data) {
    //console.log($(jsTreeId).jstree("get_selected"))
    let node = $(jsTreeId).jstree(true).get_node(data.selected);
    let selectedNode = node.original
    selectedNode.parent = data.instance.get_node(data.node.parent).text

    let shouldCallback = true;
    if(validNodeTypes) {
      if(validNodeTypes.includes(selectedNode.nodeType)) {
        //Call the callback if first node selected or different node selected
        shouldCallback = !data.instance.goodNode || data.instance.goodNode != node
        data.instance.goodNode = node;  //save a valid node if selected so I can re-select if bad one is selected
      } else {
        shouldCallback = false;
        //deselect the node and select the old node
        data.instance.deselect_node(node);
        if(data.instance.goodNode) {
          data.instance.select_node(data.instance.goodNode);
        }
      }
    }
    if (callback && shouldCallback) {
        callback(selectedNode, data);
    }
  });

  $(jsTreeId).on('open_node.jstree', function (evt, data) {
    data.instance.set_icon(data.node, 'http://jstree.com/tree-icon.png');
    //console.log(data)
    $(".jstree-icon.jstree-ocl").css(
      "rotate: transform(90deg)"
    );
  })
    .on('close_node.jstree', function (evt, data) {
      data.instance.set_icon(data.node, true);
    });

  // Initialize search
  let to = false;
  let jsTreeSearchId = jsTreeId + "-search";
  $(jsTreeSearchId).keyup(function () {
    if (to) { clearTimeout(to); }
    to = setTimeout(function () {
      var v = $(jsTreeSearchId).val();
      $(jsTreeId).jstree(true).search(v);
      //console.log($(jsTreeId).jstree(true));
    }, 250);
  });

  return treeInstance;
}

exports.searchTree = function (treeId, searchQuery) {
  let jsTreeId = "#" + treeId;
  $(jsTreeId).jstree(true).search(searchQuery);
}

exports.refreshTree = function (treeId, newData, deselect_all) {
  let jsTreeId = "#" + treeId;
  if (deselect_all)
    $(jsTreeId).jstree(true).deselect_all(true)
  $(jsTreeId).jstree(true).settings.core.data = newData;
  $(jsTreeId).jstree(true).refresh(false, true);
}

exports.uncheckAll = function(treeId) {
  let jsTreeId = "#" + treeId;
  $(jsTreeId).jstree(true).uncheck_all(true)
}

exports.deselectAll = function(treeId) {
  let jsTreeId = "#" + treeId;
  $(jsTreeId).jstree(true).deselect_all(true)
}

exports.redrawTree = function (treeId, newData, deselect_all) {
  let jsTreeId = "#" + treeId;
  $(jsTreeId).on("ready.jstree", () => {
    if (deselect_all)
    $(jsTreeId).jstree(true).deselect_all(true)
  $(jsTreeId).jstree(true).settings.core.data = newData;
  $(jsTreeId).jstree(true).redraw(true);
  })

}

exports.getNodes = function (treeId, jsTreeMethod) {
  let jsTreeId = "#" + treeId;
  let selectedNodes = [];
  $(jsTreeId).jstree(jsTreeMethod).forEach(function (node) {
    let selectedNode = $(jsTreeId).jstree(true).get_node(node).original
    selectedNodes.push(selectedNode)
  });
  return selectedNodes;
}

exports.getCheckedNodes = function (treeId) {
  return this.getNodes(treeId, "get_checked")
}

exports.checkTreeNodes = function (treeid, nodeids) {
  var tree = $("#" + treeid);
  // IE
  tree.jstree(true).check_node(nodeids);
  // Chrome or Firefox
  tree.on("loaded.jstree", function (e, data) {
    tree.jstree(true).check_node(nodeids);
  }).jstree();
}

exports.selectedNode = function (treeId, nodeId) {
  var instance = $("#" + treeId).jstree(true);
  //m = instance._model.data;
  // for(var i in m) {
  //   console.log(m[i])
  //   // if(m.hasOwnProperty(i) && i !== '#' && m[i].li_attr.name && m[i].li_attr.name === "asdf") {
  //   //     instance.select_node(i);
  //   //     break;
  //   // }
  // }
}

exports.getParentNode = function(treeId, node) {
  var instance = $("#" + treeId).jstree(true);
  //console.log(instance)
  //m = instance._model.data;

  // $('#' + treeId).on('activate_node.jstree', function(e, data) {
  //   if(data.instance.is_leaf(data.node)) {
  //     alert("Leaf: " + data.node.text);
  //     alert("Parent: " +  data.instance.get_node(data.node.parent).text);
  //   }
  // });
}



// WEBPACK FOOTER //
// ./client/app/_helpers/treeUtil.js